import { IMakeRequest } from '../../utils/make_request';
import { timeoutPromise } from '../../utils/timeout_promise';
import { parseResponse } from './helpers';
import { IValues as ISaveFormValues } from './save-form';
import { mergeBaseUri, mergePaths } from '@cian/http-api/shared';

export interface IResponse {
  phoneConfirmed: boolean;
  form: ISaveFormValues;
}

export function prefetchFormData(makeRequest: IMakeRequest, apiBaseUrl: string): Promise<IResponse> {
  return timeoutPromise(
    makeRequest({
      method: 'GET',
      uri: mergeBaseUri(apiBaseUrl, {
        path: (path: string) => mergePaths(path, '/v1/prefetch-form-data/'),
      }),
      withCredentials: true,
    }).then(parseResponse('Не удалось загрузить данные.')),
    500,
  );
}
